import $ from 'jquery';

class SmartLoaderService {
  constructor() {
    this._loaderSelector = $('#smartLoader');
    this._smartLoaderSelector = $('#smartLoader-loader');
  }

  /**
   * Open the smart loader animation
   */
  open() {
    this._loaderSelector.addClass('active').addClass('opaque');
    this._smartLoaderSelector.addClass('active');
  }

  /**
   * Dismiss the smart loader animation
   */
  close() {
    this._loaderSelector.removeClass('active').removeClass('opaque');
    this._smartLoaderSelector.removeClass('active');
  }
}

/**
 * Smart loader service instance
 * @type {SmartLoaderService}
 */
export const smartLoaderService = new SmartLoaderService();
